import { Button, styled, Tooltip, useTheme } from "@mui/material";
import { rgba } from "polished";
import PropTypes from "prop-types";

export const StyledButton = ({
  width,
  height,
  variant,
  disableLetterSpacing,
  toolTipTitle,
  ...props
}) => {
  if (props.fullWidth) {
    width = "100%";
  }
  const theme = useTheme();
  return (
    <Tooltip title={toolTipTitle} placement="top" arrow>
      <>
        <_StyledButton
          $height={height}
          $width={width}
          $theme={theme}
          $variant={variant}
          $disableLetterSpacing={disableLetterSpacing}
          {...props}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              // border: "1px solid " + rgba(theme.palette.secondary.main, 0.3),
            }}>
            {props.children}
          </div>
        </_StyledButton>
      </>
    </Tooltip>
  );
};

StyledButton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
  variant: PropTypes.oneOf(["contained", "outlined", "text"]),
  disableLetterSpacing: PropTypes.bool,
  toolTipTitle: PropTypes.string,
};

const _StyledButton = styled(Button)`
  height: ${({ $height }) => $height || "auto"};
  width: ${({ $width }) => $width || "auto"};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  background-color: ${({ $theme, $variant }) =>
    $variant === "contained"
      ? rgba($theme.palette.secondary.main, 0.2)
      : $theme.palette.background.paper};
  color: ${({ $theme }) => $theme.palette.text.primary};
  transition: all 0.3s ease;
  border-radius: 3px;
  letter-spacing: ${({ $disableLetterSpacing }) => ($disableLetterSpacing ? 0 : 1)}px;
  border: 1px solid
    ${({ $theme, $variant }) =>
      $variant === "text" ? "transparent" : rgba($theme.palette.secondary.main, 0.7)};
  &:hover {
    background-color: ${({ $theme }) => rgba($theme.palette.secondary.main, 0.2)};
    border-radius: 1px;
    border-color: ${({ $theme }) => rgba($theme.palette.primary.main, 1)};
  }
`;
